<template>
  <footer class="footer-area bg-white text-center rounded-top-7">
    <p class="fs-14">
      
    </p>
  </footer>
</template>

<script>
export default {
  name: "MainFooter",
};
</script>
